import HTTP_LOGIN from './axios-config-login'
import Router from '../router/index'
import Store from '../store'
import axios from 'axios'

/* eslint-disable no-undef */
const HTTP = axios.create({
  baseURL: (localStorage.getItem('isOnPremise') === 'yes' && process.env.NODE_ENV !== 'development' ? location.protocol + '//' + location.host : location.protocol + '//' + process.env.BASE_URL_WS_ERP),
  headers: {
    'Content-Type': 'application/json'
  }
})
// Si es on premise, la url es la misma en la que está desplegada la aplicación. DDOL hace la "redirección"
// Por si queremos hacer algo antes de ejecutar el request.
HTTP.interceptors.request.use(function (config) {
  let urlConfig = config.url

  if (localStorage.getItem('isOnPremise') === 'yes') {
    config.headers.common['x-ddol-org'] = (localStorage.getItem('datos-autenticacion') != null) ? JSON.parse(localStorage.getItem('datos-autenticacion')).organizacion : null
    config.headers.common['x-ddol-user'] = (localStorage.getItem('datos-autenticacion') != null) ? JSON.parse(localStorage.getItem('datos-autenticacion')).usuario : null
    config.headers.common['x-ddol-apporg'] = process.env.APPLICATION
    config.headers.common['x-ddol-appdst'] = process.env.APPLICATION_ERP
  }
  if (urlConfig.indexOf('/wscomun/procExpert/login') === -1) {
    config.headers.common['x-ddol-security-token'] = (localStorage.getItem('datos-autenticacion') != null) ? JSON.parse(localStorage.getItem('datos-autenticacion')).tira : null
    if (config.data) {
      if (!config.data.tira && (localStorage.getItem('datos-autenticacion') && JSON.parse(localStorage.getItem('datos-autenticacion')).tira)) {
        config.data.tira = JSON.parse(localStorage.getItem('datos-autenticacion')).tira
      }
      if (urlConfig !== '/wscomun/portalinformes/lovEmpresa' && !config.data.empresa && (localStorage.getItem('datos-autenticacion') && JSON.parse(localStorage.getItem('datos-autenticacion')).empresa)) {
        config.data.empresa = JSON.parse(localStorage.getItem('datos-autenticacion')).empresa
      }
    }
  }

  return config
}, function (error) {
  return Promise.reject(error)
})

HTTP.interceptors.response.use(function (response) {
  return response
}, function (error) {
  let request = error.config
  if (error.response.status === 401) {
    return getRefreshToken().then((result) => {
      request.headers['x-ddol-security-token'] = result
      let datosObj = JSON.parse(request.data)
      datosObj.tira = result
      request.data = JSON.stringify(datosObj)
      return axios.request(request)
    }).catch(error => {
      console.log('error token refresh7')
      Store.commit('removeAutenticacion')
      Router.push('/')
      Promise.reject(error)
    })
  } else {
    return Promise.reject(error)
  }
})

async function getRefreshToken () {
  const datosPortal = JSON.parse(localStorage.getItem('datos-portal'))
  const payload = {
    orgId: datosPortal.orgId,
    userId: datosPortal.userId,
    refreshTokenId: localStorage.getItem('refreshToken') // esgaAuth.refreshTokenId
  }
  return HTTP_LOGIN.post('/wsr/Auth/tokenRefreshGetAuth', payload).then(response => {
    let datosAuth = JSON.parse(localStorage.getItem('datos-autenticacion'))
    datosAuth.tira = response.data
    localStorage.setItem('datos-autenticacion', JSON.stringify(datosAuth))
    return response.data
  }).catch(error => {
    console.log('error token refresh8')
    Promise.reject(error)
  })
}
export default HTTP



// WEBPACK FOOTER //
// ./src/config/axios-config-login-onpremise.js